import { faAngleDown, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { useEffect, useState } from "react";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { PIPE_LINE_GET_RECRUITERS_LIST } from "../../../config/config";
import Modal from "../modal/modal";
import AddCdd from "../modal/pipline-modal/AddCdd";
import StatusFilter from "../buttons/pipeline/StatusFilter";
import ColumnFilters from "../buttons/pipeline/ColumnFilters";
import CddPipeLineTable from "./CddPipelineTable";
import ConversionRateDashboard from "./ConversionRateDashboard";
import CalculateRevenueBtn from "../buttons/pipeline/CalculateRevenueBtn";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";

interface recruitersProps {
    id : number;
    name : string;
}

interface PipelineData {
  pipeline_id : number;
  cdd_name: string;
  client_id : number;
  role : string;
  revenue: string;
  processed_date: string; 
  status: number;
  notes: string;
  projected_start_date: string; 
  client_name: string;
  career_level: string;
  cdd_num: string;
  add_candidates_or_switch_roles: string;
  last_update : string;
}

const RecruitersPipeline = () => {
    const { decodedJwtData } = useAuth() as AuthContextState;
    const [privArray] = useState<number[] | undefined>(decodedJwtData?.account_priv);
    const currentYear = new Date().getFullYear();
    const [year, setYear] = useState<number>(currentYear);
    const [reccruiters, setRecruiters] = useState<recruitersProps[] | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);

    const [recruiters_id, setRecruitersId] = useState<number>(0);
    const [recruiters_name, setRecruitersName] = useState<string>('');
    const [filterNum, setFilterNum] = useState<number[]>([]);
    const [filterCol, setFilterCol] = useState<string[]>([]);
    const [searchText, setSearchText] = useState<string>('');

    const [db_pipeline, set_db_pipeline] = useState<PipelineData[] | null>(null);

    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }
    const incrementYear = () => { 
        setYear(prevYear => prevYear + 1)
    };

    const decrementYear = () => {
        setYear(prevYear => prevYear - 1)
    };

    useEffect(()=>{
        const getRecruitersList = async() => {
            const recruiters_records = await api.get(
                PIPE_LINE_GET_RECRUITERS_LIST,{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                }
            );
            const list  = recruiters_records.data as recruitersProps[];
            const sorted_list = list.sort((a,b)=>a.name.localeCompare(b.name));
            setRecruiters(sorted_list);
            setRecruitersId(sorted_list[0].id);
            setRecruitersName(sorted_list[0].name)
        }
        getRecruitersList();
    },[]);

    return(
         <div className="content flex">
             <Helmet>
                <title>Recruiters Pipeline</title>
            </Helmet>

            <SideBar />

            <div className='main-content'>
                <div>
                    <h1 className="uppercase">
                        CDD Pipeline
                    </h1>
                </div>
                <div className="flex flex-col my-4">
                    <div className="bg-white w-full flex gap-2 py-4 px-4 shadow-xl border overflow-x-auto">
                        <div className="ms-auto flex gap-3">
                            {reccruiters && reccruiters.map(recruiter => (
                                <button onClick={()=>{
                                    setRecruitersId(recruiter.id)
                                    setRecruitersName(recruiter.name)
                                    }} className={`uppercase hover:bg-gray-200 p-2 ${recruiters_id === recruiter.id ? 'font-semibold text-orange-500' : ''}`}>
                                    {recruiter.name} &nbsp;
                                    <FontAwesomeIcon icon={faAngleDown} />
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="bg-gray-100 p-2 shadow w-full relative">
                        {/* Conversion rate dashboard */}
                        <ConversionRateDashboard pipeline={db_pipeline ?? []} recruiter={recruiters_name} />
                        <div className="flex my-2">
                            <div>
                                <input type="text" onChange={(e)=>setSearchText(e.currentTarget.value)} className="text-box h-9" placeholder="Search candidate...." />
                            </div>
                            <div className="ms-auto flex gap-4 items-center mx-2">
                                {(privArray?.includes(12) && db_pipeline) && (
                                    <CalculateRevenueBtn pipeline={db_pipeline} />
                                )}
                                <div>
                                    <ColumnFilters onFilter={(cols : string[]) => setFilterCol(cols)} />
                                </div>
                                <div>
                                    <StatusFilter onFilter={(numbers : number[])=>setFilterNum(numbers)} />
                                </div>
                                <div className="flex gap-4 text-xl text-gray-700">
                                    <div>
                                        <button className="hover:text-orange-500" onClick={decrementYear}>
                                            <FontAwesomeIcon icon={faAngleLeft} />
                                        </button>
                                    </div>
                                    <div>
                                        {year ? year : currentYear}
                                    </div>
                                    <div>
                                        <button className="hover:text-orange-500" onClick={incrementYear}>
                                            <FontAwesomeIcon icon={faAngleRight} />
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <button type="button" onClick={()=>createModalContent(<AddCdd onClose={()=>setShowModal(false)} account_id={recruiters_id} />)} className="button button-vcc-primary text-sm">
                                        Add new cdd
                                    </button>
                                </div>
                            </div>
                        </div>
                        <CddPipeLineTable 
                            u_id={recruiters_id} 
                            year={year}
                            filter={filterNum}
                            filterCol={filterCol}
                            searchFilter={searchText}
                            newCddAdded={showModal}
                            pipeline={(data)=>set_db_pipeline(data)}
                            full_access={true}
                        />
                    </div>
                </div>
            </div>
            {showModal && (
                <Modal onClose={()=>{setShowModal(false)}}> 
                    {modalChildren}
                </Modal>
            )}
        </div>
    )
}

export default RecruitersPipeline;